var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.deleteResource}},[_vm._v(" "+_vm._s(_vm.$t("handle.delete"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }